export const mergeQueryState = (...requests) => {
    return requests.reduce((acc, request) => {
        return {
            isLoading: acc.isLoading || request.isLoading,
            isSuccess: acc.isSuccess || request.isSuccess,
            isError: acc.isError || request.isError,
            isFetching: acc.isFetching || request.isFetching || false,
            isInitialLoading: acc.isInitialLoading || request.isInitialLoading || false
        };
    }, {
        isLoading: false,
        isSuccess: false,
        isError: false,
        isInitialLoading: false,
        isFetching: false
    });
};
export const mergeMutationState = (...requests) => {
    return requests.reduce((acc, request) => {
        return {
            isPending: acc.isPending || request.isPending,
            isSuccess: acc.isSuccess || request.isSuccess,
            isError: acc.isError || request.isError,
            isIdle: acc.isIdle || request.isIdle || false,
            isPaused: acc.isPaused || request.isPaused || false
        };
    }, {
        isPending: false,
        isSuccess: false,
        isError: false,
        isIdle: false,
        isPaused: false
    });
};
